<template>
  <div class="asr-create-pick-call tw-relative tw-min-w-[820px] tw-max-w-[100%]">
    <div class="tw-mb-3 tw-flex tw-items-center tw-gap-3 tw-flex-wrap">
      <CustomInput
        :value="searchTerm"
        :isSearch="true"
        placeholder="Поиск (ЖК, проект, подрядчик, этаж)"
        v-debounce:300="onSearchChange"
        class="tw-min-w-[260px]"
      />
      <span class="tw-text-grey-7 tw-text-sm">
        Принятых вызовов: {{ filteredCalls.length }}
      </span>
    </div>

    <q-linear-progress v-if="isLoading" indeterminate />

    <div v-if="!isLoading && !filteredCalls.length" class="tw-py-8">
      <NotFoundText text="Принятых вызовов не найдено" />
    </div>

    <div
      v-if="!isLoading && filteredCalls.length"
      class="asr-create-pick-call__list tw-divide-y tw-divide-grey-4 tw-border tw-border-grey-4 tw-rounded"
    >
      <div
        v-for="row in filteredCalls"
        :key="row.help_call_id"
        class="asr-create-pick-call__row tw-flex tw-items-stretch tw-gap-3 tw-p-3"
      >
        <div class="tw-flex-1 tw-min-w-0">
          <div class="tw-mt-0.5 tw-text-sm tw-text-grey-8 tw-truncate">
            <span v-if="row.block_name">Блок {{ row.block_name }}</span>
            <span v-if="row.level_num != null">
              · Этаж {{ row.level_num }}
            </span>
            <span v-if="row.work_set_check_group_name">
              · {{ row.work_set_check_group_name }}
            </span>
            <span v-if="row.placement_type_name">
              · {{ row.placement_type_name }}
            </span>
          </div>
        </div>
        <div class="tw-flex tw-flex-col tw-items-end tw-gap-1">
          <q-btn
            unelevated
            no-caps
            color="primary"
            label="Сформировать АСР"
            :disable="!this.data?.contractorId"
            @click="onPickCall(row)"
          />
          <span
            v-if="row.last_asr_date"
            class="tw-text-xs tw-text-grey-7 tw-italic"
          >
            По вызову уже есть АСР {{ row.last_asr_date }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import NotFoundText from "@/components/common/NotFoundText";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { useAppStore } from "@/services/store/app";
import { getCheckedCallsForAsr } from "@/views/ResidentialSettings/services";
import { MODAL_NAMES } from "@/constants";

export default {
  name: "AsrCreatePickCallLegacy",
  components: { CustomInput, NotFoundText },
  props: {
    data: { type: Object, required: true },
    closeModal: { type: Function, required: true },
  },
  data() {
    return {
      isLoading: false,
      calls: [],
      searchTerm: "",
    };
  },
  setup() {
    const { showErrorSnackbar, showSucceedSnackbar } = useCustomSnackbar();
    const appStore = useAppStore();
    return { showErrorSnackbar, showSucceedSnackbar, appStore };
  },
  computed: {
    filteredCalls() {
      const q = (this.searchTerm || "").toLowerCase().trim();
      if (!q) return this.calls;
      return this.calls.filter((r) =>
        [
          r.resident_name,
          r.project_name,
          r.contractor_name,
          r.block_name,
          r.work_set_check_group_name,
          r.placement_type_name,
          r.level_num,
        ]
          .filter((x) => x != null && x !== "")
          .map((x) => String(x).toLowerCase())
          .some((s) => s.includes(q))
      );
    },
  },
  mounted() {
    this.loadCalls();
  },
  methods: {
    async loadCalls() {
      this.isLoading = true;
      const rows = await getCheckedCallsForAsr({
        project_id: this.data?.projectId,
        project_entrance_id: this.data?.projectEntranceId,
      });
      this.isLoading = false;
      this.calls = Array.isArray(rows) ? rows : [];
    },
    onSearchChange(value) {
      this.searchTerm = value || "";
    },
    onPickCall(row) {
      if (!this.data?.contractorId) {
        this.showErrorSnackbar("Подрядчик проекта не назначен");
        return;
      }
      const onSuccess = this.data?.onSuccess;
      this.closeModal();
      this.appStore.showModal(MODAL_NAMES.AsrCreateOrReform, {
        title: "Акт скрытых работ",
        mode: "create",
        helpCallId: row.help_call_id,
        contractorId: this.data?.contractorId,
        residentId: this.data?.residentId,
        residentName: row.resident_name,
        contractorName: row.contractor_name,
        projectName: row.project_name,
        levelNum: row.level_num,
        blockName: row.block_name,
        documentParams: this.data?.documentParams || {},
        enableAsrFloorRange: false,
        onSuccess: (payload) => {
          if (typeof onSuccess === "function") onSuccess(payload);
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.asr-create-pick-call {
  &__list {
    max-height: 60vh;
    overflow-y: auto;
  }

  &__row {
    transition: background-color 0.15s ease;
    &:hover {
      background-color: #f5f7fa;
    }
  }
}
</style>
